module.exports = __webpack_public_path__ + "img/about-img3.e9c46d2d.png";